import axios from "axios";
import { API_URL } from "../../../../setup/config/env";

export const getPlatformUsers = ({
  page = 1,
  limit = 20,
  searchQuery = "",
  searchField = "all",
  createdAt = "all",
  year = "",
  month = "",
  role = "all",
  emailSubscription,
} = {}) => {
  return async (dispatch) => {
    try {
      const params = { page, limit };
      if (searchQuery && searchQuery.trim()) {
        params.searchQuery = searchQuery.trim();
        params.searchField = searchField;
      }
      if (createdAt && createdAt !== "all") params.createdAt = createdAt;
      if (year) params.year = year;
      if (month) params.month = month;
      if (role && role !== "all") params.role = role;
      if (emailSubscription !== undefined) params.emailSubscription = emailSubscription;

      const response = await axios.get(`${API_URL}/api/users`, { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching platform users:", error);
      throw error;
    }
  };
};

export const exportPlatformUsers = ({
  searchQuery = "",
  searchField = "all",
  createdAt = "all",
  year = "",
  month = "",
  role = "all",
  emailSubscription,
} = {}) => {
  return async (dispatch) => {
    try {
      const params = { download: true };
      if (searchQuery && searchQuery.trim()) {
        params.searchQuery = searchQuery.trim();
        params.searchField = searchField;
      }
      if (createdAt && createdAt !== "all") params.createdAt = createdAt;
      if (year) params.year = year;
      if (month) params.month = month;
      if (role && role !== "all") params.role = role;
      if (emailSubscription !== undefined) params.emailSubscription = emailSubscription;

      const response = await axios.get(`${API_URL}/api/users`, { params });
      return response.data;
    } catch (error) {
      console.error("Error exporting platform users:", error);
      throw error;
    }
  };
};
